import { createSlice, PayloadAction, createAsyncThunk, current } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";
import { InterrutApi } from "./interruptApi";
import { Console } from "console";
import { Series } from "../Common/Types/types";
import { flatten, isEqual } from "lodash";

const initialState: any = {
  interruptData: [],
  selectedSeries:[],
  loadingState: undefined,
  errorMessage: undefined,
};

const initialSeries:Series = {
  devicesWithSerial:[],
  deviceTypes:[],
  deviceName:null,
  deviceNameVersion:null
}

export const updateInterruptData = createAsyncThunk<any,any>(
  "interrupt/updateInterruptData",
  async (params:any) => {
    const response = await InterrutApi.getInterruptData(params)
    return response;
  }
);

export const addToInterruptData = createAsyncThunk<any,any>(
  "interrupt/addToInterruptData",
  async (params:any) => {
    const response = await InterrutApi.getInterruptData(params)
    return response;
  }
);

const machineHealthSlice = createSlice({
  name: "machineHealth",
  initialState,
  reducers: {
    removeSeries(state,action){
      state.interruptData = state.interruptData.filter((obj)=>!(obj.seriesID === action.payload))
      if(action.payload === "All Devices"){
        state.selectedSeries = state.selectedSeries.filter((obj)=>!isEqual(obj,initialSeries))
      }else{
        state.selectedSeries = state.selectedSeries.filter((obj)=>!(flatten(Object.values(obj)).includes(action.payload)))
      }
    },
    updateSelectedSeries(state,action){
      state.selectedSeries = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(updateInterruptData.fulfilled, (state, action) => {
      return {
        ...state,
        loadingState: "fulfilled",
        errorMessage: undefined,
        interruptData: action.payload
      };
    });
    builder.addCase(updateInterruptData.rejected, (state, action) => {
      return {
        ...state,
        loadingState: "rejected",
        errorMessage: "error",
      };
    });
    builder.addCase(updateInterruptData.pending, (state, action) => {
      return {
        ...state,
        loadingState: "pending",
        errorMessage: undefined,
      };
    });
    /////
    builder.addCase(addToInterruptData.fulfilled, (state, action) => {
      return {
        ...state,
        loadingState: "fulfilled",
        errorMessage: undefined,
        interruptData: [...state.interruptData, action.payload[0]],
      }
    });
    builder.addCase(addToInterruptData.rejected, (state, action) => {
      return {
        ...state,
        loadingState: "rejected",
        errorMessage: "error",
      };
    });
    builder.addCase(addToInterruptData.pending, (state, action) => {
      return {
        ...state,
        loadingState: "pending",
        errorMessage: undefined,
      };
    });
  },
});

export const {removeSeries, updateSelectedSeries} = machineHealthSlice.actions;
export const getInterruptsSelector = (state: RootState) => state.machineHealth;
export const loadingInterruptsSelector = (state: RootState) => state.machineHealth.loadingState;
export default machineHealthSlice.reducer;
